import * as React from 'react';

import { cn } from "@/lib/utils";

const Textarea = React.forwardRef(({ className, ...props }: React.ComponentProps<'textarea'>, ref?: React.ForwardedRef<HTMLTextAreaElement>) => {
  return (
    <textarea
      ref={ref}
      data-slot="textarea"
      className={cn(
        'placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground bg-card border-border shadow-xs flex min-h-[5rem] w-full min-w-0 rounded-md border-2 px-3 py-2 text-base outline-none transition-[color,box-shadow] disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        'focus-visible:border-ring',
        'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
        className,
      )}
      {...props}
    />
  );
})

export { Textarea };
